import PlayerSecurityInfoCard from './PlayerSecurityInfoCard.svelte';

!customElements.get('player-security-info-card') && customElements.define('player-security-info-card', PlayerSecurityInfoCard);
export default PlayerSecurityInfoCard;
